import * as React from 'react';

import { SkillPracticeRecommendation, } from './interfaces';

import useModalAccessibility from '../../../../Shared/hooks/useModalAccessibility';
import {
  pluralize,
} from '../../../../Shared/index';

interface AlreadyAssignedTargetedPracticeModalProps {
  closeModal: () => void;
  skillPracticeRecommendations: SkillPracticeRecommendation[];
}

const AlreadyAssignedTargetedPracticeModal = ({ 
  closeModal, 
  skillPracticeRecommendations,
}: AlreadyAssignedTargetedPracticeModalProps) => {
  const { modalRef } = useModalAccessibility(closeModal);

  const activityPackNameElements = skillPracticeRecommendations.length === 1
    ? <strong>{skillPracticeRecommendations[0].unit_template_name}</strong>
    : skillPracticeRecommendations.map((rec, index) => (
      <React.Fragment key={index}>
        <strong>{rec.unit_template_name}</strong>
        {index < skillPracticeRecommendations.length - 1 && ' and '}
      </React.Fragment>
    ))

  return (
    <div className="modal-container assign-targeted-practice-modal-container">
      <div className="modal-background" />
      <div
        aria-labelledby="alreadyAssignedTargetedPracticeModalTitle"
        aria-modal="true"
        className="already-assigned-targeted-practice-modal quill-modal modal-body"
        ref={modalRef}
        role="dialog"
        tabIndex={-1}
      >
        <div className="title">
          <h2 id="alreadyAssignedTargetedPracticeModalTitle">Targeted practice already assigned</h2>
        </div>

        <p>You have previously assigned {activityPackNameElements} to the selected students. You can view the {pluralize(skillPracticeRecommendations.length, 'assignment', 'assignments')} in <a href="/teachers/classrooms/activity_planner" rel="noopener noreferrer" target="_blank">Manage Activities</a>.</p>
        
        <a className="learn-more-link" href="https://support.quill.org/en/articles/12062553-how-do-i-read-the-skills-report-quill-premium" rel="noopener noreferrer" target="_blank">Learn more about targeted practice</a>
        <div className="form-buttons">
          <button 
            className='quill-button contained medium green focus-on-light' 
            onClick={closeModal} 
            type="button"
          >
            Ok, got it
          </button>
        </div>
      </div>
    </div>
  )
}

export default AlreadyAssignedTargetedPracticeModal
